import React from "react";
import './Loading.css'
const Loading = props => {
    return (
        <div className="container-loading">
            <div className="loading"/>
        </div>
    )
}

export default Loading